// Plan IDs
export const PLAN_IDS = {
  CUSTOM: 999,
  IMPORTED: 998,
  C25K: 4,
};

// Breakpoints (in pixels)
export const BREAKPOINTS = {
  MOBILE: 768, // md breakpoint in Tailwind
};

// Theme colors mapped to specific color values
export const THEME_COLORS = {
  'bg-sky-500': {
    bg100: '#e0f2fe',
    name: 'Sky',
  },
  'bg-purple-500': {
    bg100: '#f3e8ff',
    name: 'Purple',
  },
  'bg-emerald-500': {
    bg100: '#d1fae5',
    name: 'Emerald',
  },
  'bg-orange-500': {
    bg100: '#ffedd5',
    name: 'Orange',
  },
};

// Default theme background for light mode
export const DEFAULT_LIGHT_BG = '#f1f5f9'; // slate-100

// Default dark background
export const DEFAULT_DARK_BG = '#0f172a'; // slate-900

// Run types
export const RUN_TYPES = {
  EASY: 'easy',
  LONG: 'long',
  WORKOUT: 'workout',
  RECOVERY: 'recovery',
  CROSS: 'cross',
};

// Run statuses
export const RUN_STATUS = {
  PLANNED: 'planned',
  COMPLETED: 'completed',
};

// Swipe threshold (in pixels)
export const SWIPE_THRESHOLD = 75;

// Double click delay (in milliseconds)
export const DOUBLE_CLICK_DELAY = 250;

// Animation durations (in milliseconds)
export const ANIMATION = {
  BOTTOM_SHEET: 300,
  PULL_TO_REFRESH: 300,
};

// File types
export const FILE_TYPES = {
  CSV: '.csv',
};

// Rest day icon options
export const REST_DAY_ICONS = {
  sleep: {
    icon: '💤',
    name: 'Sleep',
    color: 'blue',
    borderLight: 'border-blue-400',
    borderDark: 'border-blue-500',
    bgLight: 'bg-blue-50',
    bgDark: 'bg-blue-950',
    textLight: 'text-blue-600',
    textDark: 'text-blue-400',
  },
  battery: {
    icon: '🔋',
    name: 'Battery',
    color: 'green',
    borderLight: 'border-green-400',
    borderDark: 'border-green-500',
    bgLight: 'bg-green-50',
    bgDark: 'bg-green-950',
    textLight: 'text-green-600',
    textDark: 'text-green-400',
  },
  meditation: {
    icon: '🧘',
    name: 'Meditation',
    color: 'purple',
    borderLight: 'border-purple-400',
    borderDark: 'border-purple-500',
    bgLight: 'bg-purple-50',
    bgDark: 'bg-purple-950',
    textLight: 'text-purple-600',
    textDark: 'text-purple-400',
  },
  moon: {
    icon: '🌙',
    name: 'Moon',
    color: 'indigo',
    borderLight: 'border-indigo-400',
    borderDark: 'border-indigo-500',
    bgLight: 'bg-indigo-50',
    bgDark: 'bg-indigo-950',
    textLight: 'text-indigo-600',
    textDark: 'text-indigo-400',
  },
  heart: {
    icon: '❤️‍🩹',
    name: 'Heart',
    color: 'pink',
    borderLight: 'border-pink-400',
    borderDark: 'border-pink-500',
    bgLight: 'bg-pink-50',
    bgDark: 'bg-pink-950',
    textLight: 'text-pink-600',
    textDark: 'text-pink-400',
  },
  ice: {
    icon: '🧊',
    name: 'Ice',
    color: 'cyan',
    borderLight: 'border-cyan-400',
    borderDark: 'border-cyan-500',
    bgLight: 'bg-cyan-50',
    bgDark: 'bg-cyan-950',
    textLight: 'text-cyan-600',
    textDark: 'text-cyan-400',
  },
};
